import React from 'react';
import { EventCategory, EventAction } from '../../../../services/ga';
import AnalyticsFactory from '../../../../services/analytics-factory';

const PhoneLink: React.FC<{
	phoneNumber: string;
	action: EventAction;
	children: JSX.Element | string;
}> = ({ phoneNumber, action, children }) => {
	const gaTracking = () => {
		//TODO - implement hoc for link with analytics prop similar to Button
		const analytics = AnalyticsFactory.createAnalytics('ga');
		analytics.sendSimpleEvent(
			EventCategory.Help,
			action,
			`${window.location.href}`
		);
	};

	return (
		<a
			href={'tel:' + phoneNumber}
			className="no-underline print:text-font"
			onClick={gaTracking}
			aria-label={`Phone  ${phoneNumber}`}>
			{children}
		</a>
	);
};

export default PhoneLink;
